import { createPage } from "./create-page";
import Component from "./App.vue";

createPage(Component);
